import React from 'react';
import { Grid } from '@mui/material';
import BackButton from './BackButton';
import InfoModal from 'components/BiteAI/InfoModal';

interface IContentLayoutProps {
  children?: React.ReactNode;
  title: string | undefined;
  compact?: boolean;
}

const ContentLayout: React.FC<IContentLayoutProps> = (
  props: IContentLayoutProps,
) => {
  const { children, title, compact } = props;
  return (
    <section
      className='content-body HeaderDown'
      style={compact ? { minHeight: 0, marginTop: '24px' } : { minHeight: 0 }}
    >
      <BackButton />
      <Grid container>
        <Grid item xs={12}>
          <div className='LayoutTitle'>
            <h2>{title}</h2>
            {title === 'Bite Score' && (
              <div className='width-fit cursor-pointer'>
                <p className='b-dark font-weight-400 margin-0'>Documentation</p>
              </div>
            )}
            {title === 'Bite GPT' && <InfoModal />}
          </div>
        </Grid>
        <div className='Tab-container Dashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default ContentLayout;
